import { render, staticRenderFns } from "./RuTermsOfUse.vue?vue&type=template&id=4f1eab88&scoped=true"
import script from "./RuTermsOfUse.vue?vue&type=script&lang=js"
export * from "./RuTermsOfUse.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4f1eab88",
  null
  ,true
)

export default component.exports